import type { ComponentType } from "react";
import DebitNotePdfComponent from "./DebitNotePdf.jsx";

const DebitNotePdf = DebitNotePdfComponent as ComponentType<any>;
export default DebitNotePdf;
